module.exports = __webpack_public_path__ + "static/media/11.0f9df9e3.jpg";